import React, { useState } from 'react';
import { Card, List, Avatar, Tag, Button, Form, Input, Select, message, Space } from 'antd';
import { MessageOutlined, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';

const FeedbackSystemModule = () => {
  const [feedbacks, setFeedbacks] = useState([
    { id: 1, user: '张三', type: 'bug', title: '地图导出功能在 Safari 浏览器崩溃', status: 'pending', time: '2025-11-27' },
    { id: 2, user: 'Lisa', type: 'suggestion', title: '建议增加英文界面支持', status: 'resolved', time: '2025-11-26' },
  ]);
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    setFeedbacks([{
      id: Date.now(),
      user: '当前用户',
      type: values.type,
      title: values.title,
      status: 'pending',
      time: new Date().toISOString().split('T')[0]
    }, ...feedbacks]);
    message.success('反馈提交成功！');
    form.resetFields();
  };

  return (
    <div style={{ padding: 24 }}>
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <Card title="提交新反馈">
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item name="type" label="反馈类型" initialValue="bug">
              <Select>
                <Select.Option value="bug">问题报告 (Bug)</Select.Option>
                <Select.Option value="suggestion">功能建议</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="title" label="标题" rules={[{ required: true }]}><Input /></Form.Item>
            <Form.Item name="content" label="详细描述"><Input.TextArea rows={3} /></Form.Item>
            <Button type="primary" htmlType="submit">提交反馈</Button>
          </Form>
        </Card>

        <Card title="反馈列表">
          <List
            dataSource={feedbacks}
            renderItem={item => (
              <List.Item actions={[item.status === 'pending' && <Button size="small">处理</Button>]}>
                <List.Item.Meta
                  avatar={<Avatar icon={<UserOutlined />} />}
                  title={<Space><b>{item.user}</b> <Tag color={item.type === 'bug' ? 'red' : 'blue'}>{item.type}</Tag></Space>}
                  description={
                    <div>
                      <div>{item.title}</div>
                      <div style={{ fontSize: 12, color: '#999', marginTop: 5 }}>{item.time} - {item.status === 'resolved' ? <span style={{color: 'green'}}>已解决</span> : '待处理'}</div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        </Card>
      </Space>
    </div>
  );
};

export default FeedbackSystemModule;